import { useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { Box, CircularProgress } from "@mui/material";
import ImgBg from "../../assets/images/indexes/bg-material.svg";
import { getConstituentsFile } from "../../services";
import { downloadFileInBrowser } from "../../utils";
import { useStyles } from "./styles";

interface Props {
  type: string;
  url: string;
  background: string;
  fileIndex: number;
  fileName: string;
  indexId: string;
}

const BCAUEE_CUSTOM_URL = "https://cedarportfolio.com/main/wp-content/uploads/2021/12/The-Cedar-Austrian-Economics-ESG-Index-Investment-Strategy-Latest.pdf"; // TODO: It is hardcoded for now due to high priority, in a next iteration it will be removed and certain features will be made @andrea_da_silva @paul_herrera [IT-14218]
const BCAUEE_INDEX = "BCAUEE";

const Material: React.FC<Props> = ({
  type,
  url,
  background,
  fileIndex,
  fileName,
  indexId,
}) => {
  const classes = useStyles();

  const [downloading, setDownloading] = useState<boolean>(false);

  const handleOpenPdf = () => {
    if(indexId === BCAUEE_INDEX) { // TODO: It is hardcoded for now due to high priority, in a next iteration it will be removed and certain features will be made @andrea_da_silva @paul_herrera [IT-14218]
      window.open(BCAUEE_CUSTOM_URL, "_blank");
    } else if (url) {
      window.open(url, "_blank");
    }
  };

  const handleDownloadConstituentsFile = async () => {
    try {
      if (fileIndex && !downloading) {
        setDownloading(true);
        const file = await getConstituentsFile(indexId);
        downloadFileInBrowser(file, fileName, false);
        setDownloading(false);
      }
    } catch (error) {
      setDownloading(false);
    }
  };

  const handleClick = () => {
    if (type === "constituents_list") {
      handleDownloadConstituentsFile();
    } else {
      handleOpenPdf();
    }
  };

  return (
    <Box
      className={classes.container}
      sx={{
        background,
      }}
      onClick={handleClick}
    >
      <Box
        className={classes.background}
        sx={{ backgroundImage: `url(${ImgBg})` }}
      ></Box>
      <Box className={classes.title}>INDEX RESOURCES</Box>
      <Box className={classes.content}>
        <Box className={classes.type}>{type.split("_").join(" ")}</Box>
        <Box>
          {downloading ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            <DownloadIcon />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Material;
